<template>
  <div class="w100 Contenido">
    <Modal ref="Modal" v-show="ModalVisible" @Cerrar="CerrarModal" />
    <ModalEdicion ref="ModalEdicion" v-show="ModalEdicionVisible" @Cerrar="CerrarModalEdicion" />
    <ModalEditarRegistro ref="ModalEditarRegistro" />

    <Titulo
      seccion="Registro Pluviométrico Mensual"
      icon="filter"
      :productor="NombreProductor()"
      :establecimiento="NombreEstablecimiento()"
    />
    <Descripcion>Consiste en el registro mensual de la precipitación acumulada a lo largo del ciclo de cultivo.</Descripcion>
    <div class="SeccionLatLon cP" v-on:click.stop="EditarPluviometro()">
      <span>Editar coordenadas </span>
      <font-awesome-icon
      icon="edit" size="4x" :style="{ color: '#348E54'}" :class="{ 'Titilando': Titilando()}"  class="h100 IconoEditar"/>
    </div>

    <div class="DivInfoData" v-bind:class="{ 'Visible': !DataActualizada }" ref="DivInfoData">
      <div class="fLeft">
        Info recuperada de fecha: <span ref="FechaData"></span>
      </div>


      <div class="fRight" v-on:click.stop="RefrescarInfo(InfoPluviometro._IdPluviometro)">
        <font-awesome-icon  icon="sync-alt" size="4x" :style="{ color: 'white'}"  class="IconoActualizar fLeft"/>
        <!-- Actualizar -->
        <div class="clear"></div>
      </div>

      <div class="clear"></div>
    </div>
    <div>
        <table>
        <thead>
            <tr>
            <th>Valor</th>
            <th>Fecha</th>
            <th class="pR">
                <font-awesome-icon
                v-on:click.stop="NuevoRegistro()"
                v-show="this.$parent.Datos.AdminLogueado()"
                icon="plus-circle" size="4x" :style="{ color: '#005625'}" class="IconoAgregar Centro"/>
            </th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(p, index) in RegistrosPag" :key="index">
            <td class="c1">{{ p._Valor }} mm</td>
            <td>{{ p._FechaAlta }}</td>
            <td class="c3">
                <font-awesome-icon
                v-show="p._Id > 0 && AdminLogueado() && Online()"
                v-on:click.stop="EditarRegistro(p)"
                icon="edit"
                size="4x"
                class="h100 cP IconoEditar"
                />
                <font-awesome-icon
                v-show="p._Id > 0 && AdminLogueado() && Online()"
                v-on:click.stop="EliminarRegistro(p._Id, InfoPluviometro._IdPluviometro)"
                icon="trash-alt"
                size="4x"
                :style="{ color: '#934141' }"
                class="h100 cP mL10"
                />
                <font-awesome-icon
                v-show="p._Id <= 0"
                icon="spinner"
                size="4x"
                :style="{ color: '#000000' }"
                class="h100 cP fa fa-spinner fa-spin"
                />
            </td>
            </tr>
        </tbody>
        </table>
    </div>
    <div class="SinRegistros" v-show="this.MostrarSinRegistros">
      Aún no hay registros para este período...
    </div>

    <SlidingPagination
      v-show="totalPages > 1"
      :slidingEndingSize="2"
      :slidingWindowSize="2"
      :current="currentPage"
      :total="totalPages"
      @page-change="CambioDePagina"
    ></SlidingPagination>

    <!-- <GraficoLineal TituloEjeX="" TituloEjeY="ml" :DataEjeX="this.chartOptions" :DataEjeY="this.series"/> -->
    <GraficoLineal v-if="DataEjeX.length > 0" TituloEjeY="ml" :DataEjeX="DataEjeX" :DataEjeY="DataEjeY" :Acumulativo="true"/>
    <!-- <div class="ContenedorGrafico">
      <apexcharts class="GraficoBarras" type="bar" :options="chartOptions" :series="series"></apexcharts>
    </div> -->


    <div class="BotonVerMapa dIB" @click="ClickVerMapa()">Ver Mapa</div>
    <br>
    <div v-if="AdminLogueado()" class="BotonVerMapa dIB clear Warn" @click="FinalizarPeriodo()">Finalizar período actual e iniciar nuevo</div>
    <!-- PERIODOS -->
    <div v-if="Object.keys(this.InfoMaxGraficoExtra).length > 0" class="ContenedorRegistrosAnteriores aliCenter">
      <hr>
      <u>Registros anteriores</u>
      <div class="w100 aliCenter ContenedorPeriodos mT10">
        <div v-for="(p, i) in Object.values(this.InfoMaxGraficoExtra)" :key="i" :class="ClasePeriodoClickeado(i)" @click="GraficoExtraCambiarPeriodo(i+1)">
          {{p._FechaInicio}} - {{p._FechaFin}}
        </div>

        <!-- <sliding-pagination
            :slidingEndingSize="1"
            :slidingWindowSize="1"
            :current="GraficoExtraPaginaActual"
            :total="Object.keys(this.InfoMaxGraficoExtra).length"
            @page-change="GraficoExtraCambiarPeriodo">
        </sliding-pagination> -->
      </div>

      <GraficoLineal
        v-if="InfoGraficoExtra.DataEjeX.length > 0"
        TituloEjeY="ml"
        :DataEjeX="InfoGraficoExtra.DataEjeX"
        :DataEjeY="InfoGraficoExtra.DataEjeY" :Acumulativo="true"
      />
    </div>
  </div>
</template>

<script>
import SlidingPagination from "vue-sliding-pagination";
import Modal from '../../components/Utilidades/ModalNuevoRegistroPluviometro';
import ModalEditarRegistro from '../../components/Utilidades/ModalEditarRegistroPluviometro';
import axios from "axios";
import Clases from "../../Auxiliares/Clases.js";
import ManejoDatos from "../../Auxiliares/ManejoDatos.js";
import GraficoLineal from '../../components/Utilidades/GraficoLineal';
import Titulo from '../../components/Titulo.vue';
import Descripcion from "../../components/Descripcion.vue";
import ModalEdicion from '../../components/EdicionLatLon';

export default {
  name: "Pluviometro",
  data() {
    return {
      InfoPluviometro: null, //El modelo lo setea la API
      RegistrosPag: [],
      MostrarSinRegistros: false,
      DataActualizada: true,
      _UserOk: false,
      Error: null,
      ModalVisible: false,
      ModalEdicionVisible: false,
      DataEjeX: [],
      DataEjeY: [],
      //Paginado
      currentPage: 0,
      totalPages: 0,
      ItemsPorPagina: 5,
      RecalcularPaginado(_InfoPluviometro) {
        let _RegistrosPeriodoActual = _InfoPluviometro._Registros[this.InfoPluviometro._PeriodoActual];
        this.totalPages = Math.ceil(
          _RegistrosPeriodoActual.length / this.ItemsPorPagina
        );
        var _Aux = [];
        for (let i = 0; i < _RegistrosPeriodoActual.length; i++) {
          if (i >= (this.currentPage - 1) * this.ItemsPorPagina) {
            if (i < this.currentPage * this.ItemsPorPagina) {
              //this.RegistrosPag.push(_InfoPluviometro._Registros[i]);
              _Aux.push(_RegistrosPeriodoActual[i]);
            }
          }
        }
        this.RegistrosPag = _Aux;
        this.MostrarSinRegistros = this.RegistrosPag.length <= 0;
      },
      NombreProductor(){
        if (this.InfoPluviometro != null){
          return this.InfoPluviometro._Productor;
        }
        return "";
      },
      NombreEstablecimiento(){
        if (this.InfoPluviometro != null){
          return this.InfoPluviometro._Establecimiento;
        }
        return "";
      },
      Latitud(){
        if (this.InfoPluviometro != null){
          return this.InfoPluviometro._Latitud;
        }
        return "";
      },
      Longitud(){
        if (this.InfoPluviometro != null){
          return this.InfoPluviometro._Longitud;
        }
        return "";
      },
      Online(){
        return this.$parent.Datos.AppOnline();
      },
      AdminLogueado(){
        return this.$parent.Datos.AdminLogueado();
      },
      Titilando(){
        if(this.InfoPluviometro){
          if(this.InfoPluviometro._Latitud == "" || this.InfoPluviometro._Longitud == ""){
            return true;
          }
        }
        return false;
      },
      GraficoExtraPaginaActual: 0,
      InfoGraficoExtra: {
        DataEjeX: [],
        DataEjeY: []
      },
      InfoMaxGraficoExtra: { }
    };
  },
  mounted() {
    this._UserOk = this.$parent.Datos.ChequearSesionUsuario(this.$router);
    if (this._UserOk) {
      this.RefrescarInfo(this.$route.params.Id);
      this.RefrescarInfoGraficoExtra();
    }
  },
  methods: {
    RefrescarInfo(_IdPluviometro){
      _IdPluviometro = _IdPluviometro || this.$route.params.Id;
      if(this.VistaActual(_IdPluviometro)){
        this.IntentoObtenerDataDeCache(_IdPluviometro);
      }
      ManejoDatos.ObtenerRegistrosPluviometro(_IdPluviometro, this);
    },
    VistaActual(_IdPluviometro){
      return (this.$route.params.Id == _IdPluviometro && this.$route.name == "Pluviometro");
    },
    AuxiliaresVista(_IdPluviometro){
      if(this.VistaActual(_IdPluviometro)){
        this.currentPage = 1;
        this.AgregarPendientes(_IdPluviometro);
        this.RecalcularPaginado(this.InfoPluviometro);
        var _Data = this.ObtenerDataGrafico(this.InfoPluviometro._PeriodoActual);
        this.DataEjeX = _Data.DataEjeX;
        this.DataEjeY = _Data.DataEjeY;
        this.GraficoExtraPaginaActual = 0;
        this.RefrescarInfoGraficoExtra();
      }
    },
    AgregarPendientes(_IdPluviometro){
      var _Pendientes = Clases.RecuperarJsonDeStorage(this.KeyRegistrosPendientes(_IdPluviometro));
      if(_Pendientes != null){
        _Pendientes.forEach(_Reg => {
          var _Reg = {
            _Id: 0,
            _Valor: _Reg.Valor,
            _FechaAlta: new Clases.Fecha()._Fecha
          };
          this.InfoPluviometro._Registros[this.InfoPluviometro._PeriodoActual].unshift(_Reg);
        });
      }
    },
    IntentoObtenerDataDeCache(_IdPluviometro){
      try {
        var _Data = Clases.RecuperarJsonDeStorage(ManejoDatos.KeyDataCacheadaPluviometros(_IdPluviometro));
        if (_Data != null){
          this.InfoPluviometro = _Data._Json;
          this.$refs.FechaData.innerHTML = _Data._Fecha._FechaYHora;
        }
      } catch (e) {
        console.log(e);
      }
    },
    KeyRegistrosPendientes(_IdPluviometro){
      return ManejoDatos._KeyRegistrosPendientesGeneralPluviometros + _IdPluviometro;
    },
    CambioDePagina(selectedPage) {
      this.currentPage = selectedPage;
      this.RecalcularPaginado(this.InfoPluviometro);
    },
    ObtenerDataGrafico(_IdPeriodo) {
      var _Retorno = {
        DataEjeX: [],
        DataEjeY: []
      };
      try {
        var AuxX = [];
        var AuxY = [];

        if (this.InfoPluviometro){
          let _RegistrosPeriodoActual = [];
            _RegistrosPeriodoActual = this.InfoPluviometro._Registros[_IdPeriodo];
            if(_RegistrosPeriodoActual.length > 0){
              for (let index = 0; index < 7; index++) {
                const element = _RegistrosPeriodoActual[index];
                if(element){
                  AuxX.push(element._FechaAlta);
                  AuxY.push(element._Valor);
                }else{
                  AuxX.push("-");
                  AuxY.push(0);
                }
              }
            }
        }

        AuxX.reverse();
        AuxY.reverse();

        _Retorno.DataEjeX = AuxX;
        _Retorno.DataEjeY = AuxY;

      } catch (error) {

      }
      return _Retorno;
    },
    NuevoRegistro(){
      this.$refs.Modal.Setear(this.InfoPluviometro._IdPluviometro);
      this.VerModal();
    },
    VerModal() {
      this.ModalVisible = true;
      setTimeout(() => {
          this.$refs.Modal.$refs.Valor.focus()
      }, 200);
    },
    CerrarModal() {
      this.ModalVisible = false;
    },
    EditarPluviometro(){
      this.ModalEdicionVisible = true;
      this.$refs.ModalEdicion.Editar(this.InfoPluviometro, this.InfoPluviometro._IdPluviometro, 1);
    },
    CerrarModalEdicion() {
      this.ModalEdicionVisible = false;
    },
    SetearNuevasCoordenadas(_Lat, _Lon){
      this.InfoPluviometro._Latitud = _Lat;
      this.InfoPluviometro._Longitud = _Lon;
    },
    EliminarRegistro(_Id, _IdPluviometro){
      var _This = this;
      //alert(_Nombre);
      this.$confirm({
        title: "ATENCIÓN",
        message: "Estás seguro de eliminar el registro?",
        button: {
          yes: 'Si',
          no: 'No'
        },
        callback: confirm => {
          if(confirm){
            axios
              .post(_This.urlPosts + "/AgroIdeas/BajaRegistroPluviometro", {
                IdUsuario: _This.$parent.Datos._User._ID,
                IdRegistro: _Id
              })
              .then(function (response) {
                _This.$parent.Notificacion("Registro eliminado!", "", "success", 3);
                _This.RefrescarInfo(_IdPluviometro);
              })
              .catch(function (error) {
                _This.$parent.Notificacion("Error!", "", "error", 3);
                console.error(error);
              })
              .then(function () {
                //console.log("Ok");//LLega siempre que no haya catch
              });
          }
        }
      })
    },
    ClickVerMapa(){
      this.$router.push("/vermapa?t=1&idpres=" + this.$route.params.Id);
    },
    FinalizarPeriodo(){
      this.$confirm({
        title: "ATENCIÓN",
        message: "Estás seguro de finalizar el período actual e iniciar uno nuevo?",
        button: {
          yes: 'Si',
          no: 'No'
        },
        callback: confirm => {
          if(confirm){
            var _This = this;
            axios
              .post(_This.urlPosts + "/AgroIdeas/FinalizarPeriodoPluviometro", {
                IdPluviometro: _This.InfoPluviometro._IdPluviometro,
                PeriodoActual: _This.InfoPluviometro._PeriodoActual
              })
              .then(function (response) {
                _This.$parent.Notificacion("Nuevo período iniciado!", "", "success", 3);
                _This.RefrescarInfo(_This.$route.params.Id);
              })
              .catch(function (error) {
                _This.$parent.Notificacion("Error!", "", "error", 3);
                console.error(error);
              })
              .then(function () {
                //console.log("Ok");//LLega siempre que no haya catch
              });
          }
        }
      })
    },
    ListaPeriodosAnteriores(){
      var _Retorno = [];
      try {
        if(this.InfoPluviometro){
          if(this.InfoPluviometro._Registros){
              _Retorno = Object.keys(this.InfoPluviometro._Registros);
              _Retorno.pop(); //Elimino el primer id ya que es el que se está viendo actualmente
          }
        }
      } catch (error) {
        console.log(error);
      }
      return _Retorno;
    },
    GraficoExtraCambiarPeriodo(PaginaSeleccionada){
      try {
        this.GraficoExtraPaginaActual = PaginaSeleccionada;
        this.RefrescarInfoGraficoExtra();
      } catch (error) {
        console.log(error);
      }
    },
    RefrescarInfoGraficoExtra(){
      var _Periodos = this.ListaPeriodosAnteriores();
      if(this.GraficoExtraPaginaActual == 0){
        this.GraficoExtraPaginaActual = _Periodos.length;
      }
      //console.log(_Periodos);
      if(_Periodos.length > 0){
        var _Data = this.ObtenerDataGrafico(_Periodos[this.GraficoExtraPaginaActual-1]);
        this.InfoGraficoExtra.DataEjeX = _Data.DataEjeX;
        this.InfoGraficoExtra.DataEjeY = _Data.DataEjeY;
      }
      this.InfoMaxGraficoExtra = {};
      for (let i = 0; i < _Periodos.length; i++) {
        var _InfoRegistros = this.InfoPluviometro._Registros[_Periodos[i]];
        var _FechaInicio = "";
        var _FechaFin = "";
        if(_InfoRegistros.length > 0){
          _FechaInicio = _InfoRegistros[_InfoRegistros.length-1]._FechaAlta;
          _FechaFin = _InfoRegistros[0]._FechaAlta;
        }
        this.InfoMaxGraficoExtra[_Periodos[i]] = {
          _Registros: _InfoRegistros,
          _FechaInicio: _FechaInicio,
          _FechaFin: _FechaFin
        };
      }
      //console.log(Object.keys(this.InfoMaxGraficoExtra).length);
    },
    ClasePeriodoClickeado(i){
      if(this.GraficoExtraPaginaActual == i + 1){
        return "BotonPeriodoFocus BotonPeriodo";
      }else{
        return "BotonPeriodo";
      }
    },
    EditarRegistro(_Registro){
      this.$refs.ModalEditarRegistro.Show(_Registro);
    },

  },
  components: {
    SlidingPagination,
    Modal,
    GraficoLineal,
    Titulo,
    Descripcion,
    ModalEdicion,
    ModalEditarRegistro
  },
};
</script>

<style lang="scss" scoped>
.c1 {
  width: 40%;
}
.c3 {
  width: 20%;
}
.Verde {
  background-color: white;
  color: black;
  border: 2px solid #4caf50;
}

.Verde:hover {
  background-color: #4caf50;
  color: white;
}

.Azul {
  background-color: white;
  color: black;
  border: 2px solid #008cba;
}

.Azul:hover {
  background-color: #008cba;
  color: white;
}

.Gris {
  background-color: white;
  color: black;
  border: 2px solid #e7e7e7;
}

.Gris:hover {
  background-color: #e7e7e7;
}

.Negro {
  background-color: white;
  color: black;
  border: 2px solid #555555;
}

.Negro:hover {
  background-color: #555555;
  color: white;
}

@media only screen and (max-width: 900px) {
  .table-wrapper {
    width: 90%;
    margin: 0 5%;
    overflow-x: scroll;
  }
}
  .IconoEditar{
    width: 30px !important;
  }
  .ContenedorRegistrosAnteriores{
    width:100%;
    padding:0 10px;
    box-sizing: border-box;
  }
  .ContenedorPeriodos{
    display:flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }
  .BotonPeriodo{
    background-color: rgba(0,0,0,0.6);
    color:#FFF;
    border-radius: 5px;
    text-align: center;
    margin: 0 10px 10px 10px;
    padding:5px 10px;
    cursor:pointer;
    transition: background-color 0.1s ease;
  }
  .BotonPeriodoFocus{background-color: rgba(0,0,0,0.9);}
</style>
